module.exports = __webpack_public_path__ + "img/quayRampBus.1fc2f99a.svg";